// socket.js
import { io } from 'socket.io-client';
import { API_BASE_URL } from './api.js';

// Create the socket once and reuse it
const socket = io(API_BASE_URL, {
  withCredentials: true,
  autoConnect: false, // We'll manually connect it
  reconnection: true,
  reconnectionDelay: 2000,
  auth: {
    DealershipID: "Registration"
  }
});
export default socket;
